/**
 * Class representation of a Health Issue
 * 
 * @author Floyd Kissoon
 * @since 20180613
 */
export class HealthIssue
{
    id: number;
    name: string;
    description: string;
    user_id: number;
    created_at: Date;
    updated_at: Date;
    deleted_at: Date;
}
